import React, { useState, useEffect } from 'react'
import './styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import TotalBudgetWidgets from '../../../widgets/projectProposal/budget/TotalBudgetWidgets'
// import ManagementFeeWidget from '../../../widgets/projectProposal/budget/ManagementFeeWidget'
import ContributionBudgetWidgets from '../../../widgets/projectProposal/budget/ContributionBudget/ContributionBudgetWidgets'
import ActivityBudgetWidgets from '../../../widgets/projectProposal/budget/ActivityBudgetWidgets'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getBudget, getSummary } from '../../../redux/actions/budget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function Budget() {
  const [isEditWidget, setIsEditWidget] = useState({})
  // const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [summaryBudget, setSummaryBudget] = useState()
  const [showEditAll, setShowEditAll] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getBudget(projectId)
      // console.log('Budget ', JSON.stringify(_schema))
      setSummaryBudget(_schema?.forms?.summary)
      setSchema(_schema)

      doCalculateEditWidget(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSummary = async () => {
    try {
      const _schema = await getSummary(projectId)
      // console.log('handleGetSummary', _schema)
      setSummaryBudget(_schema)
    } catch (e) {}
  }

  const doCalculateEditWidget = (_schema) => {
    let editObj = {
      activity: _schema?.forms?.activity?.value?.length > 0 ? false : true,
      other: _schema?.forms?.other?.value?.length > 0 ? false : true,
    }

    let managementFee = true

    _schema?.forms?.managementFee?.forEach((item, index) => {
      if (item.form.headerOnly) {
        item.subForms.forEach((subSchema, subIndex) => {
          editObj[`subForms_${subIndex}`] = subSchema?.values?.length > 0 ? false : true
          // managementFee = managementFee && !subSchema.disabled
        })
      } else {
        editObj[`managementFeeWidget_${index}`] = item.form?.values?.length > 0 ? false : true
        // managementFee = managementFee && !item.form.disabled
      }
      managementFee = managementFee && !item.form.disabled
    })

    let activity = schema?.forms?.activity && !schema.forms.activity.disabled
    let other = schema?.forms?.other && !schema.forms.other.disabled

    setIsEditWidget(editObj)
    setShowEditAll(activity && managementFee && other)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProject>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          />
        )}

        {schema?.forms?.activity && (
          <>
            <ActivityBudgetWidgets
              showCommandButton={!schema.forms.activity.disabled}
              isEdit={isEditWidget.activity}
              getSummary={handleGetSummary}
              schema={schema.forms.activity}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('activity', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}

        {summaryBudget && (
          <>
            <TotalBudgetWidgets schema={summaryBudget} />
            <br />
          </>
        )}

        {schema?.forms?.other && (
          <>
            <ContributionBudgetWidgets
              showCommandButton={!schema.forms.other.disabled}
              isEdit={isEditWidget.other}
              schema={schema.forms.other}
              onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('other', _isEdit, setIsEditWidget)}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
